import { render, staticRenderFns } from "./ProfitLossPortfolioTableSubHistory.vue?vue&type=template&id=d77918dc&"
import script from "./ProfitLossPortfolioTableSubHistory.vue?vue&type=script&lang=js&"
export * from "./ProfitLossPortfolioTableSubHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports